'use strict';
angular.module('MW.ContactManager.TransformOutreachStatsChart', ['DashboardChartConfigService', 'CoreColorService'])
    .service('TransformOutreachStatsChartService', [
        'DashboardChartConfigService',
        'CoreColorService',
        '$translate',
        'RECIPIENT_TRACKING_CHECKS',
        function(DashboardChartConfigService, CoreColorService, $translate, RECIPIENT_TRACKING_CHECKS) {
        var serviceObj = {};

        serviceObj.readyChartUnsubscribeData = function readyChartUnsubscribeData(data, drilldownFunction) {
            var chartData;

            chartData = {
                chart: {
                    height: 314
                },
                plotOptions: {
                    pie: {
                        center: ['50%', '50%'],
                        animation: true,
                        dataLabels: {
                            distance: 5
                        }
                    },
                    series: {
                        point: {
                            events: {
                                click: function() {
                                    drilldownFunction(this);
                                }
                            }
                        }
                    }
                },
                series: [{
                    data: data,
                    innerSize: '47%',
                    size: '86%',
                    type: 'pie',
                    dataLabels: {
                        formatter: function () {
                            var dataLabel;
                            if(this.point.name.length >= 23) {
                                dataLabel = this.point.name.substr(0,23) + '...';
                            }
                            return dataLabel || this.point.name;
                        }
                    }
                }],
                tooltip: {
                    hideDelay: 0
                }
            };

            return chartData;
        };

        serviceObj.readyChartCTORData = function readyChartCTORData(data, drilldownFunction) {
            var chartData;

            chartData = {
                chart: {
                    height: 314
                },
                xAxis: {
                    labels: {
                        useHTML: true,
                        align: 'left',
                        x: 6,
                        y: 5,
                        style: {
                            color: CoreColorService.colors.grey80,
                            whiteSpace: 'nowrap'
                        },
                        formatter: function() {
                            var chartWidth = this.chart.clipBox.height,
                                ourWidth = 0.75 * chartWidth,
                                value;

                            value = DashboardChartConfigService.getTruncatedText(this.value, ourWidth, this.chart.userOptions.xAxis.labels.style);
                            return '<div style="font-size: 11px; text-align: left; min-width: 300px;">' + value + '</div>';
                        }
                    }
                },
                yAxis: {
                    gridLineWidth: 1,
                    title: {
                        text: ''
                    }
                },
                tooltip: {
                    enabled: false
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: false
                        },
                        pointWidth: 28
                    },
                    series: {
                        point: {
                            events: {
                                click: function() {
                                    drilldownFunction(this);
                                }
                            }
                        }
                    }
                }
            };

            return chartData;
        };

        serviceObj.readyChartOpenRateStatsData = function readyChartOpenRateStatsData(data, tooltipFunction, drilldownFunction) {
            var chartData;

            tooltipFunction = tooltipFunction || function() {};
            drilldownFunction = drilldownFunction || function() {};

            if (RECIPIENT_TRACKING_CHECKS === true) {
                chartData = {
                    chart: {
                        height: 304
                    },
                    yAxis: {
                        min: 0
                    },
                    xAxis: {
                        categories: [
                            $translate.instant('Bounced'),
                            $translate.instant('icm-outreach-stats__open-rate--unopened'),
                            $translate.instant('icm-outreach-stats__open-rate--opened'),
                            $translate.instant('icm-outreach-stats__open-rate--untracked'),
                        ]
                    },
                    plotOptions: {
                        series: {
                            colorByPoint: true,
                            dataLabels: {
                                enabled: true,
                                formatter: function() {
                                    return this.y;
                                }
                            },
                            point: {
                                events: {
                                    click: function() {
                                        drilldownFunction(this);
                                    }
                                }
                            }
                        },
                        column: {
                            colors: ['#3399ff', '#3399ff', '#3399ff', '#d1cece']
                        }
                    },
                    tooltip: {
                        formatter: function() {
                            return tooltipFunction(this.point);
                        },
                        hideDelay: 0
                    },
                    series: [{
                        data: [
                            {y: data.bounces, type: 'bounces'},
                            {y: data.unopened, type: 'unopened'},
                            {y: data.opened, type: 'opened'},
                            {y: data.untracked, type: 'untracked'}
                        ]
                    }]
                };
            }
            else {
                chartData = {
                    chart: {
                        height: 304
                    },
                    yAxis: {
                        min: 0
                    },
                    xAxis: {
                        categories: [
                            $translate.instant('Bounced'),
                            $translate.instant('icm-outreach-stats__open-rate--unopened'),
                            $translate.instant('icm-outreach-stats__open-rate--opened')
                        ]
                    },
                    plotOptions: {
                        series: {
                            dataLabels: {
                                enabled: true,
                                formatter: function() {
                                    return this.y;
                                }
                            },
                            point: {
                                events: {
                                    click: function() {
                                        drilldownFunction(this);
                                    }
                                }
                            }
                        }
                    },
                    tooltip: {
                        formatter: function() {
                            return tooltipFunction(this.point);
                        },
                        hideDelay: 0
                    },
                    series: [{
                        data: [
                            {y: data.bounces, type: 'bounce'},
                            {y: data.unopened, type: 'unopened'},
                            {y: data.opened, type: 'opened'}
                        ]
                    }]
                };
            }


            return chartData;
        };

        return serviceObj;
    }]);
